/* unplugin-vue-components disabled */import script from "./Sweet.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sweet.vue?vue&type=script&setup=true&lang=ts"

import "./Sweet.vue?vue&type=style&index=0&id=66c5e85e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c5e85e"]])

export default __exports__